module.exports = __webpack_public_path__ + "media/images/mobile/abouts/about-mb-bg-f5bf44ed1ebbd7f1139ebc6baac4045a.png";